import {InjectionToken} from "@angular/core";

export const SCROLL_PROVIDER = new InjectionToken("scroll provider");

export interface IScrollProvider {
  getScrollContainer(): Element;
}

export class WindowScrollProvider implements IScrollProvider {
  getScrollContainer(): Element {
    return window.document.documentElement;
  }
}
